import Vue from 'vue';
import axios from 'axios';


export default {


    async logoutUser({ state, commit, dispatch }, isTimeout = false){
        return new Promise(async (resolve, reject) => {
            if(state.allowNotAuthenticatedUser === false) {
                reject('allowNotAuthenticatedUser is false')
                return;
            };
            commit('SET_CLEARING_MODEL', true);
            setTimeout(async () => {
                try{
                    commit('LOGOUT_USER', {isTimeout});
                    await dispatch('clearModels');
                    await dispatch('removeLocalData');
                    dispatch('afterLogout');
                    commit('SET_CLEARING_MODEL', false);
                    resolve();
                }
                catch(e){
                    reject(e);
                }
            }, 500);
        });
    },

    afterLogout (){

    },

    async loginUser({ commit, dispatch, getters }, credentials){
        return axios.post(
            `${getters.apiRootUrl}/auth/login/`,
            credentials
        ).then(response => {
            if(getters.hasOwnProperty('IsUserAllowedToLogin')){
                if (!getters.IsUserAllowedToLogin(response.data)){
                    return Promise.reject({
                        response: {
                            status: 403,
                            data: {_errors: 'INSUFFICIENT_PERMISSIONS'}
                        }
                    });
                }
            }
            if(!response.data.hasOwnProperty('is_verified') || response.data.is_verified){
                commit('LOGIN_USER', response.data);
                dispatch('fetchSelfUser');
                dispatch('loadModels');
            }
            return Promise.resolve(response.data);
        }).catch((error) => {
            dispatch('logoutUser');
            return Promise.reject(error.response);
        });
    },
    async loginLDAPUser({ commit, dispatch, getters }, credentials){
        return axios.post(
            `${getters.apiRootUrl}/${getters.LDAPConnectionRoute}`,
            credentials
        ).then(response => {
            commit('LOGIN_USER', response.data);
            dispatch('fetchSelfUser');
            dispatch('loadModels').catch(() => {});
            return Promise.resolve(response.data);
        }).catch((error) => {
            dispatch('logoutUser');
            return Promise.reject(error.response);
        });
    },

    async checkVerificationCode ({getters }, data){
        let url = '/auth/two-factor/login/';
        let twoFactorData = {
            email: data.email,
            token: data.token,
            verification_code: data.verification_code,
        };
        return axios.post(
            `${getters.apiRootUrl}${url}`,
            twoFactorData
        ).catch((e) => {
            return Promise.reject(e.response);
        });
    },

    async registerUser({ getters }, { email, password }){
        return axios.post(`${getters.apiRootUrl}/register/`, {
            email: email,
            password: password
        })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error.response));
    },


    async selfRegisterUser({ getters, commit, dispatch}, credentials){
        return axios.post(`${getters.apiRootUrl}/auth/register/`, credentials)
            .then((response) => {

                if(getters.hasOwnProperty('IsUserAllowedToLogin')){
                    if(!getters.IsUserAllowedToLogin(response.data)){
                        return Promise.reject({
                            response: {
                                status: 403,
                                data: {_errors: 'INSUFFICIENT_PERMISSIONS'}
                            }
                        });
                    }
                }
                commit('LOGIN_USER', response.data);
                dispatch('fetchSelfUser');
                dispatch('loadModels').catch(() => {});
                return Promise.resolve(response.data);
            })
            .catch((error) => Promise.reject(error.response));
    },

    // demande de reset de mdp (envoie un email)
    async selfResetUserPassword({ getters }, credentials){
        credentials.url_format = '/#/reset-password/?token={token}&email={email}';
        return axios.post(`${getters.apiRootUrl}/auth/reset-password/`, credentials);
    },

    async listSecurityRyles({getters}){
        return axios.options(`${getters.apiRootUrl}/auth/register/`).then(response => {
            return response.data.rules;
        });
    },

    async changeUserPassword(context, credentials){
        return this.axios.post('/auth/change-password/', credentials);
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-auth/actions.js
// module id = null
// module chunks = 